import React, { useState } from 'react';
import { UUID } from '../../../types/shared/UUID';
import { AppointmentsList } from '../../../components/order/scheduling/appointmentsList/AppointmentsList';
import { Show } from '../../../components/shared/Show';
import { useSetOrderNavigationTab } from '../../../utilities/hooks/useSetOrderNavigationTab';
import { CreateAppointmentWizard } from '../../../components/order/scheduling/CreateSigningAppointment/CreateAppointmentWizard';
import { AppointmentContainer } from '../../../components/order/scheduling/SigningAppointmentDetails/AppointmentContainer';
import { useParams } from 'react-router-dom';
import { useSomeAppointmentFromParam } from '../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { useSigningAppointmentErrorToasts } from '../../../utilities/order/scheduling/useSigningAppointmentErrorToasts';
import { OrderTabs } from 'store/order/orderNavigation/orderNavigationSlice';

export const SchedulingContainer: React.FC = () => {
  useSetOrderNavigationTab({ tab: OrderTabs.Scheduling });
  const { appointmentId } = useParams<{ orderId: UUID; appointmentId?: UUID }>();
  const { isAppointmentSelected, setAppointmentParam } = useSomeAppointmentFromParam();
  const [{ showWizard, correctionId }, setCreateSigningAppointment] = useState<{
    showWizard: boolean;
    correctionId?: UUID;
  }>({ showWizard: false });

  useSigningAppointmentErrorToasts();

  const onAddEventClick = (correctionId?: UUID) => {
    setAppointmentParam();
    setCreateSigningAppointment({ showWizard: true, correctionId });
  };

  const onCloseCreateEventClick = () => {
    setCreateSigningAppointment({ showWizard: false });
  };

  const onViewAppointment = (appointmentId?: UUID) => {
    setCreateSigningAppointment({ showWizard: false });
    setAppointmentParam(appointmentId);
  };

  return (
    <section className={'grid grid-cols-2 gap-4'}>
      <section>
        <AppointmentsList onAddEventClick={onAddEventClick} onViewAppointment={onViewAppointment} />
      </section>
      <section>
        <Show when={isAppointmentSelected}>
          <AppointmentContainer
            key={appointmentId}
            onAddEventClick={onAddEventClick}
            onClose={() => setAppointmentParam()}
          />
        </Show>
        <Show when={showWizard}>
          <CreateAppointmentWizard onClose={onCloseCreateEventClick} correctionId={correctionId} />
        </Show>
      </section>
    </section>
  );
};
